import * as React from 'react';
import WaitingRoom from 'containers/WaitingRoom';
import { Navigate, Outlet } from 'react-router';
import { userSession } from 'state/session';
import { tenantConfig } from 'utils/tenant';

const CustomerEntry: React.FC = () => {
  const [ready, setReady] = React.useState(false);
  const session = userSession().useState();
  tenantConfig().useState();

  // if voip is disabled, the user is automatically ready
  const userReady = userSession().voipEnabled ? ready : true;
  const canAccessSharedSession = session.isShared;
  const canAccessPresentation = userReady && userSession().customerCanAccessPresentation;
  const waitingRoomCandidate = !canAccessPresentation;

  if (canAccessSharedSession && !waitingRoomCandidate && !userSession().presentationCompleted) {
    return <Outlet />;
  }

  if (userSession().sessionEnded) {
    return <Navigate to={`/${session.brand}/${session.market}/view/${session.id}/goodbye`} />;
  }

  return <WaitingRoom {...{ ready, setReady }} />;
};

export default CustomerEntry;
